
export const convertToArray = (value) => {

    if (typeof value === 'string' || value instanceof String)
        return [value]
    else
        return value

};